/**
 * Shared Settings-tab primitives.
 *
 * These lived as unexported locals at the bottom of SettingsPage.jsx. That file
 * has exactly one export, which is the whole reason five tabs are inline in a
 * 970-line file: a tab could not move out without losing its card chrome.
 *
 * AccountTab.jsx is what happens when one moves out anyway — it hand-rolls a
 * <section> painted with `var(--surface-secondary)`, a token defined nowhere in
 * the repo, so that card renders with no background at all. The real token is
 * `--bg-secondary` (theme.css). Extracting these removes the reason to hand-roll.
 *
 * Moved verbatim. No restyling: 42 call sites depend on the current look.
 */
import React from 'react';

export function VPCard({ title, children }) {
  return (
    <div style={{ backgroundColor: 'var(--bg-secondary)', border: '1px solid var(--border-color)', color: 'var(--text-primary)', borderRadius: 16, padding: 24 }}>
      {title && <h2 className="font-headline font-bold text-base mb-4" style={{ color: 'var(--text-primary)' }}>{title}</h2>}
      {children}
    </div>
  );
}

export function Label({ children }) {
  return <label className="block mb-1.5 ml-0.5" style={{ fontSize: 11, fontWeight: 700, color: 'var(--text-secondary)', textTransform: 'uppercase', letterSpacing: '0.04em' }}>{children}</label>;
}

export function Row({ label, value }) {
  return (
    <div className="flex justify-between py-1">
      <span style={{ color: 'var(--text-secondary)' }}>{label}</span>
      <span className="font-medium" style={{ color: 'var(--text-primary)' }}>{value}</span>
    </div>
  );
}
